// src/components/layout/PlatformAdminLayout.js
import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './PlatformAdminLayout.css';

const PlatformAdminLayout = () => {
    const { userData, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const isDashboard = location.pathname === '/platform-admin' || location.pathname === '/platform-admin/'; // Adjust based on your actual route

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error("Error al cerrar sesión", error);
        }
    };

    return (
        <div className="platform-layout">
            <header className="platform-header">
                <div className="platform-header-content">
                    {isDashboard ? (
                        // Header específico para Dashboard (Imagen 1)
                        <>
                            <div className="header-left-section">
                                <h1 className="header-dashboard-title">Panel de Administración</h1>
                                <p className="header-dashboard-subtitle">
                                    Bienvenido, <strong>{userData?.nombre || 'Jonnatan Wong'}</strong>. Gestiona tu plataforma desde aquí.
                                </p>
                            </div>
                            <div className="header-right-section">
                                <span className="header-user-email">{userData?.email || 'manager.wong@test.com'}</span>
                                <button onClick={handleLogout} className="btn-logout-custom">
                                    Cerrar Sesión
                                </button>
                            </div>
                        </>
                    ) : (
                        // Header genérico para otras páginas (preservando lo anterior o simplificando)
                        <>
                            <div className="platform-header-left">
                                <div className="platform-header-title">
                                    Administración de Plataforma
                                </div>
                            </div>
                            <div className="platform-user-info">
                                <div className="user-details">
                                    <span className="user-name">{userData?.nombre || 'Administrador'}</span>
                                </div>
                                <button onClick={handleLogout} className="btn-logout" title="Cerrar Sesión">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                        <polyline points="16 17 21 12 16 7"></polyline>
                                        <line x1="21" y1="12" x2="9" y2="12"></line>
                                    </svg>
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </header>

            <main className="platform-content">
                <Outlet />
            </main>
        </div>
    );
};

export default PlatformAdminLayout;